// extracted by mini-css-extract-plugin
export default {"link":"NoPermissions-NoPermissionMessage__link--D6euR"};